/**
 * Normalize select_block postMessage payloads between admin (event) and preview (type/message).
 */
export function parseSelectBlockMessage(data) {
  if (!data || typeof data !== "object") return null;

  if (data.event === "select_block") {
    return {
      type: data.type,
      index: data.index,
      subIndex: data.subIndex,
    };
  }

  if (data.type === "select_block" && data.message) {
    return {
      type: data.message.type,
      index: data.message.index,
      subIndex: data.message.subIndex,
    };
  }

  return null;
}

export function ackSelectBlockToParent({ type, index, subIndex }) {
  const payload = {
    type,
    index,
    ...(typeof subIndex === "number" && subIndex >= 0 ? { subIndex } : {}),
  };

  window.parent?.postMessage(
    { type: "select_block", message: payload },
    "*"
  );
  window.parent?.postMessage({ event: "select_block", ...payload }, "*");
}

/** Click outside popup blocks — return host to Elements tree and clear preview chrome. */
export function ackDeselectToParent() {
  window.parent?.postMessage({ type: "deselect_block" }, "*");
  window.parent?.postMessage({ event: "deselect_block" }, "*");
}

export function isDeselectBlockMessage(data) {
  if (!data || typeof data !== "object") return false;
  return data.event === "deselect_block" || data.type === "deselect_block";
}
